export class Agency {
    id: number;
    code: string;
    name: string;
    status: string;   
    createdBy: number;
    updatedBy: number;
}
